import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getTagsByGroup = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/tagGroup', METHOD_TYPES.GET, data, callback);
};

export const joinChatRoom = (data, callback) => {
  return fetchDataAndProceed('admin/v1/joinChatRoom', METHOD_TYPES.POST, data, callback, 8000);
}

export const getJoinedRoomUserProfile = (data, callback) => {
  return fetchDataAndProceed('admin/v1/getUserProfile', METHOD_TYPES.POST, data, callback);
}

export const shownJcrContent = data => {
  return fetchDataAndProceed('admin/v1/shownJcrContent', METHOD_TYPES.POST, data, () => { });
}



// WEBPACK FOOTER //
// ./src/data/redux/chats_details/api.js